/**
 * Const with StaticQuery element
 * Footer component
 * Display a footer
 */
/* Import section */
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import { IconContext } from "react-icons"
import { BsArrowLeftShort } from "react-icons/bs"
import "../styles/components/footer.scss"

/* Declaration function with StaticQuery */
const Footer = ({ logopc }) => {
  return (
    <footer className="main-footer">
      <div className="wrap-maincontent">
        <div className="box-footer-nav">
          <p>
            <a className="link-arrow" href="https://hellohealth.com/" target="_blank" rel="noreferrer">
              <span className="span-arrow">
                <IconContext.Provider value={{ className: "icon-arrow" }}>
                  <BsArrowLeftShort />
                </IconContext.Provider>
              </span>
              <span>hellohealth.com</span>
            </a>
          </p>
          <p><a href="https://hellohealth.com/support/" target="_blank" rel="noreferrer">Support</a></p>
          {logopc && <a className="link-logopc" href="https://portalconnect.net/" target="_blank" rel="noreferrer"><StaticImage src="../images/logo_portalconnect_2020_white_byhh.png" alt="Logo PortalConnect" layout="fixed" width={230} height={50} quality={100} /></a>}
        </div>
        <div className="box-copyright">
          <p>Hello Health Inc. ©{new Date().getFullYear()}</p>
          <p><a href="https://hellohealth.com/terms-of-use/" target="_blank" rel="noreferrer">Terms of Use</a></p>
          <p><a href="https://hellohealth.com/privacy/" target="_blank" rel="noreferrer">Privacy</a></p>
        </div>
      </div>
    </footer>
  )
}

/* Export function */
export default Footer
